// Source: https://v8.dev/blog/react-cliff#value-representation
// eslint-disable-next-line import/prefer-default-export
export const MAX_SMALL_INTEGER = 2 ** 30 - 1;
